<template>
  <div class="newsletter__form__checkbox">
    <label :for="name" class="newsletter__form__label">
      <input
        type="checkbox"
        :name="name"
        :id="name"
        :value="value"
        :required="required"
        :readonly="readonly"

        @invalid="showInputError"

        v-model="checked" />
      <slot></slot>
    </label>
    <span class="newsletter__form__validation newsletter__form__validation_checkbox" v-if="inputErrorVisible">{{ inputErrorText }}</span>
  </div>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    value: {
      type: String
    },
    inputError: {
      type: Object
    }
  },
  data() {
    return {
      inputErrorVisible: false,
      inputErrorText: ''
    }
  },
  watch: {
    checked() {
      this.hideInputError()
    }
  },
  methods: {
    showInputError(event) {
      event.preventDefault()

      this.inputErrorVisible = true
      this.inputErrorText = this.inputError.valueMissing
    },
    hideInputError() {
      this.inputErrorVisible = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// Checkbox.vue?f045d916